import {every} from 'lodash';
import {of} from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import {DataSourceFilter} from './filters/data-source.filter';

export class DataSource extends MatTableDataSource<any> {
    private appliedFilters: object = {};

    constructor() {
        super();
        of(this.filteredData).subscribe(() => this.refreshPageIndex());
    }

    public readonly filterPredicate = (data: any, _: string): boolean => {
        const filterNamesToBeApplied = Object.keys(this.appliedFilters);
        const filterResult = every(filterNamesToBeApplied, filterName => {
            const {filter, parameters} = this.appliedFilters[filterName];
            return (filter as DataSourceFilter).filter(data, parameters);
        });
        this.refreshPageIndex();
        return filterResult;
    };

    public applyFilter(filter: DataSourceFilter, parameters: any): this {
        this.removeFilter(filter);
        this.appliedFilters[filter.identifier()] = {filter: filter, parameters: parameters};
        this.filter = 'filter-applied';
        return this;
    }

    public removeFilter(filter: DataSourceFilter): void {
        delete this.appliedFilters[filter.identifier()];
    }

    private refreshPageIndex() {
        if (this.paginator) {
            if (this.paginator.pageIndex >= this.paginator.getNumberOfPages()) {
                this.paginator.firstPage();
            }
        }
    }
}
